var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-other") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-other",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,14.6666667 L8.66666667,14.6666667 C7.930287,14.6666667 7.33333333,14.069713 7.33333333,13.3333333 L7.33333333,12 C7.33333333,11.2636203 7.930287,10.6666667 8.66666667,10.6666667 L23.3333333,10.6666667 C24.069713,10.6666667 24.6666667,11.2636203 24.6666667,12 L24.6666667,13.3333333 C24.6666667,14.069713 24.069713,14.6666667 23.3333333,14.6666667 L18,14.6666667",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,14.6666667 L22.6666667,14.6666667 L22.088,22.7613333 C22.0382353,23.4605071 21.455607,24.0017688 20.7546667,24.0000043 L11.2413333,24.0000043 C10.540393,24.0017688 9.95776469,23.4605071 9.908,22.7613333 L9.33333333,14.6666667 L14,14.6666667",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 10.6666667,
    x2: 14,
    y2: 24,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 24,
    x2: 18,
    y2: 10.6666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333333,8.91733333 C12.1333333,9.72266667 16,10.6666667 16,10.6666667 C16,10.6666667 15.0546667,6.8 14.2506667,6 C13.4450673,5.19440067 12.1389327,5.19440068 11.3333334,6.00000002 C10.527734,6.80559937 10.527734,8.11173397 11.3333333,8.91733333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6666667,8.91733333 C19.8666667,9.72266667 16,10.6666667 16,10.6666667 C16,10.6666667 16.9453333,6.8 17.7493333,6 C18.2704647,5.47886859 19.0300303,5.27534361 19.7419091,5.46609094 C20.4537878,5.65683828 21.0098284,6.21287887 21.2005757,6.92475761 C21.3913231,7.63663635 21.1877981,8.39620193 20.6666667,8.91733333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 0,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.428,
    y1: 5.90533333,
    x2: 26.8426667,
    y2: 4.492,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.3333333,
    y1: 14.6666667,
    x2: 31.3333333,
    y2: 14.6666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.572,
    y1: 5.90533333,
    x2: 5.15733333,
    y2: 4.492,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.66666667,
    y1: 14.6666667,
    x2: 0.666666667,
    y2: 14.6666667,
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsOther);
export default __webpack_public_path__ + "static/media/icons-other.d3b38e72d6a1a0056573a09da3c7148d.svg";
export { ForwardRef as ReactComponent };